// extracted by mini-css-extract-plugin
module.exports = {"root":"Discount_root__g2GS3","discount":"Discount_discount__JNyGP"};